/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type ImageKind = typeof ImageKind[keyof typeof ImageKind];


export const ImageKind = {
  covers: 'covers',
  avatars: 'avatars',
  categories: 'categories',
  collection_covers: 'collection_covers',
  collection_banners: 'collection_banners',
  banners: 'banners',
  emotion_icons: 'emotion_icons',
  emotion_images: 'emotion_images',
} as const;
